<template>
  <div class="position-translate-center">
    <div class="col-auto">
      <div class="clearfix">
        <h1 class="float-start display-3 me-4">401</h1>
        <h4 class="pt-3">認証されていません</h4>
        <p class="text-medium-emphasis">The page you are looking for was unauthenticated.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorUnauthenticated",
}
</script>
